export const MAX_EDGES_FOR_GRAPH = 1000;
export const MAX_EDGES_FOR_EXPORT = 200_000;
